import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import moment from 'moment-timezone';
import dayjs from 'dayjs';
import { antdLocaleFor } from './antdLocale';
import { CATALOGS } from '../../resources/lang/registry.generated';
import LocalizationManager, {
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
  TRANSLATED_LANGUAGES,
} from './LocalizationManager';
import { isFoodAmigosHost } from '../branding/hosts';

// Before the brand is known: German on FoodAmigos' own hosts (its home market), English
// on the shared white-label hosts. BrandProvider re-aligns the language with the brand
// as soon as it settles (see brandLanguages.js).
const DEFAULT_LANGUAGE = isFoodAmigosHost(window.location.hostname) ? 'de' : FALLBACK_LANGUAGE;

const languageDetector = {
  type: 'languageDetector',
  async: true,

  init: (_services, _detectorOptions, _i18nextOptions) => {},
  detect: (callback) => {
    const languageFromUrl = LocalizationManager.getLanguageFromUrl();

    if (languageFromUrl) {
      return callback(languageFromUrl);
    }

    const browserLanguage = LocalizationManager.getLanguage();

    if (!browserLanguage) {
      const preferredLanguage = LocalizationManager.getPreferredLanguage();

      if (!preferredLanguage) {
        return callback(DEFAULT_LANGUAGE);
      }

      return callback(preferredLanguage);
    }

    return callback(browserLanguage);
  },
  cacheUserLanguage: (lng) => {
    LocalizationManager.saveLanguage(lng);
    moment.locale(lng);
    dayjs.locale(antdLocaleFor(lng).dayjs);
  },
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    resources: CATALOGS,
    react: {
      useSuspense: false,
    },
    // Untranslated region languages (es, fr, …) always read English. Translated ones
    // only fall back in production, so missing keys stay visible while developing.
    fallbackLng: (language) =>
      TRANSLATED_LANGUAGES.includes(language) && !import.meta.env.PROD ? [] : [FALLBACK_LANGUAGE],
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  // antd's date components format with dayjs, which keeps one global locale.
  dayjs.locale(antdLocaleFor(lng).dayjs);
});
